import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {LoadScript} from "@react-google-maps/api"
import {useAddressPosition, useDataResponse, useMenu} from "../utils/recoil";
import GoogleMapComponent from "../components/GoogleMapComponent";
import GauageHighChartContainer from "../components/GauageHighChartContainer";
import Gauage from "../components/Gauage";
import Alert from "../images/Alert.svg";
import CasualtiesByUserGroupContainer from "../components/CasualtiesByUserGroupContainer";
import HeatMap from "../components/HeatMap";
import AccidentTrend from "../components/AccidentTrend";
import CasualtySeverity from "../components/CasualtySeverity";
import CasualtiesByUserGroup from "../components/CasualtiesByUserGroup";
import Night from "../images/Night.svg";
import Sun from "../images/Sun.svg";
import RoadWet from "../images/RoadWet.svg";
import Precipitation from "../images/Precipitation.svg";
import CasualtyAge from "../components/CasualtyAge";
import homeLocation from "../images/home-location.svg";
import {WindowSize} from "../utils/functionality";
import Footer from "../components/Footer";
import TopBarHeader from "../components/TopBarHeader";
import ButtonGroup from "../components/ButtonGroup";
import ReactGA4 from "react-ga4";
import RatingElement from "../components/RatingElement";
import InputName from "../components/InputName";
import axios from "axios";
import Ok from "../images/OK.svg";

const libraries = ["places"]

export default function Page3() {
    const {t, i18n} = useTranslation()
    const [elevation, setElevation] = useState(0)
    // const [dataAll, setDataAll] = useDataResponse()
    const [dataAll, setDataAll] = useState(JSON.parse(sessionStorage.getItem("reportData")))
    // const [addressStart, setAddressStart] = useAddressPosition()
    const [addressStart, setAddressStart] = useState(JSON.parse(sessionStorage.getItem("address")))
    const [ratingOne, setRatingOne] = useState(0)
    const [okOne, setOkOne] = useState(false)
    const [ratingTwo, setRatingTwo] = useState(0)
    const [okTwo, setOKTwo] = useState(false)
    const [ratingText, setRatingText] = useState('')
    const [ratingTextAfter, setRatingTextAfter] = useState(0)
    const [okText, setOKText] = useState(false)
    const [menu, setMenu] = useMenu()
    const center = {
        lat: dataAll?.map300m?.mainPoint?.latitude,
        lng: dataAll?.map300m?.mainPoint?.longitude,
    }
    const markers300m = []
    const markers10km = []
    dataAll?.map300m?.hotSpots?.forEach((spot) => {
        markers300m.push({lat: spot.latitude, lng: spot.longitude})
    })
    dataAll?.map10km?.hotSpots?.forEach((spot) => {
        markers10km.push({lat: spot.latitude, lng: spot.longitude})
    })

    useEffect(() => {
        // ReactGA4.send({ hitType: "pageview", page:'/report', label:'3 - Risk Report'});
        ReactGA4.event({category: 'event', action: '3 - Risk Report', label: '3 - Risk Report'})
        window.scrollTo(0, 0)
    }, [])

    WindowSize(setMenu);

    function sendDataRating(qId, gt, at, setShow) {
        let config = {
            headers: {},
            params: {
                userId: dataAll?.userRequestId,
                qId: qId,
                qt: gt,
                at: at
            }
        }
        let data = {
            "userId": dataAll?.userRequestId,
            "qId": qId,
            "qt": gt,
            "at": at
        }
        axios.get(process.env.REACT_APP_API_URL_RATING, config).then((response) => {
            console.log(response.status)
            if (response.status === 200) {
                setShow(true)
            }
        }).catch((error => {
            console.log(error)
        })).finally(() => {
        })
    }

    useEffect(() => {
        if (ratingOne) {
            sendDataRating(1, "How safety information important to you?", ratingOne.toString(), setOkOne)
        }
    }, [ratingOne])

    useEffect(() => {
        if (ratingTwo) {
            sendDataRating("2", "How the information in the report useful to you?", ratingTwo.toString(), setOKTwo)
        }
    }, [ratingTwo])

    useEffect(() => {
            if (ratingText) {
                sendDataRating("3", "Would you like to receive any additional information in your report?",
                    ratingText.toString(), setOKText)
                setRatingTextAfter(1)
            }
        },
        [ratingText])

    useEffect(() => {
        window.onscroll = function () {
            if (window.scrollY !== 0) {
                setElevation(3)
            } else {
                setElevation(0)
            }
        };
    }, [window.scrollY])

    const createArray = (obj, arrayKeys) => {
        let temp = []
        if (obj) {
            arrayKeys.forEach((item) => {
                temp.push({y: obj[item.key]})
            })
        }
        return temp
    }

    const GaugeConfig = () => {
        let temp = []
        let score = dataAll?.safetyScoreData?.np
        temp.push({y: score > 0 ? score : 0, name: score})
        Gauage.series[0].data = temp
        Gauage.series[0].dataLabels.y = window.innerWidth > 767 ? -65 : -55
        Gauage.series[0].dataLabels.style = window.innerWidth > 768 ? {
            fontFamily: 'Stolzl-Medium',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '54px',
            lineHeight: '64px'
        } : {
            fontFamily: 'Stolzl-Medium',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '48px',
            lineHeight: '56px'
        }
        return {...Gauage}
    }

    const HeatMapConfig = () => {
        HeatMap.title.text = t('days_hours_chart_subtitle')
        let tempHeatMapArray = []
        const categories = ['', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
        HeatMap.series[0].data = tempHeatMapArray
        HeatMap.chart.backgroundColor = "#F5F5F5"
        HeatMap.chart.borderWidth = 1
        HeatMap.chart.borderColor = "#FFFFFF"
        if (window.innerWidth > 768) {
            HeatMap.title.y = window.innerWidth > 1023 ? 20 : 10
            HeatMap.title.x = window.innerWidth > 1023 ? 20 : 10
            HeatMap.chart.marginTop = window.innerWidth > 1023 ? 80 : 60
            HeatMap.chart.height = window.innerWidth > 1024 ? 272 : 246
            HeatMap.title.style = window.innerWidth > 1023 ? {
                fontFamily: 'Stolzl-Medium',
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: '18px',
                lineHeight: '30px',
                color: '#3D3935'
            } : {
                fontFamily: 'Stolzl-Medium',
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px',
                color: '#3D3935'
            }
            HeatMap.xAxis.labels.style = {
                fontStyle: 'normal',
                fontSize: "11px",
                fontFamily: 'Roboto',
                fontWeight: '400',
                lineHeight: "16px",
                color: '#777572',
                transform: "rotate(0deg)!important"
            }
            HeatMap.yAxis.labels.style = {
                fontStyle: 'normal',
                fontSize: "11px",
                fontFamily: 'Roboto',
                fontWeight: '400',
                lineHeight: "16px",
                color: '#777572',
            }
            HeatMap.yAxis.categories = ['', t('days_mon'), t('days_tue'), t('days_wed'), t('days_thu'),
                t('days_fri'), t('days_sat'), t('days_sun')]
            HeatMap.xAxis.categories = ['6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '0:00']
            categories.forEach((key, index) => {
                if (dataAll?.accidentsByDayAndTime) {
                    dataAll?.accidentsByDayAndTime[key]?.slice(5, dataAll?.accidentsByDayAndTime[key]?.length)?.forEach((array) => {
                        tempHeatMapArray.push([array[0] - 6, index, array[1]])
                    })
                }
            })
        } else {
            HeatMap.xAxis.labels.style = {
                fontStyle: 'normal',
                fontSize: "11px",
                fontFamily: 'Roboto',
                margin: "0!important",
                padding: "0!important",
                fontWeight: '400',
                lineHeight: "16px",
                color: '#777572',
            }
            HeatMap.yAxis.labels.style = {
                fontStyle: 'normal',
                fontSize: "11px",
                fontFamily: 'Roboto',
                fontWeight: '400',
                lineHeight: "16px",
                color: '#777572',
            }
            HeatMap.chart.height = 448
            HeatMap.xAxis.categories = ['', t('days_mon'), t('days_tue'), t('days_wed'), t('days_thu'),
                t('days_fri'), t('days_sat'), t('days_sun')]
            HeatMap.yAxis.categories = ['', '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '0:00']
            categories.forEach((key, index) => {
                if (dataAll?.accidentsByDayAndTime) {
                    dataAll?.accidentsByDayAndTime[key]?.slice(5, dataAll?.accidentsByDayAndTime[key]?.length)?.forEach((array) => {
                        tempHeatMapArray.push([index, array[0] - 5, array[1]])
                    })
                }
            })

        }
        return {...HeatMap}
    }

    const AccidentTrendConfig = () => {
        let temp = []
        let categories = []
        AccidentTrend.chart.marginTop = window.innerWidth > 1023 ? 55 : 40
        AccidentTrend.chart.height = window.innerWidth > 1023 ? 154 : window.innerWidth > 768 ? 128 : 110
        AccidentTrend.xAxis.labels.style.fontSize = window.innerWidth > 1023 ? 12 : 11
        AccidentTrend.plotOptions.line.dataLabels.style.fontSize = window.innerWidth > 1023 ? 12 : 11
        if (dataAll?.accidentsTrends) {
            let accidentsTrends = dataAll?.accidentsTrends;
            accidentsTrends = [...accidentsTrends].sort((a, b) => a.year - b.year)
            accidentsTrends.forEach((obj, index) => {
                categories.push(obj.year)
            })
            let percentageSum = 0;
            Object.keys(accidentsTrends).forEach((key) => {
                percentageSum += accidentsTrends[key]?.percentage;
                temp.push({
                    y: percentageSum,
                    name: accidentsTrends[key]?.percentage > 0 ? '+' + accidentsTrends[key]?.percentage.toString() : accidentsTrends[key]?.percentage.toString(),
                    color: "#FFB946"
                })
            })
        }
        if (window.innerWidth > 768) {
            AccidentTrend.chart.maxWidth = window.innerWidth > 1023 ? 462 : 334
            AccidentTrend.chart.width = window.innerWidth > 1023 ? 462 : 334
            AccidentTrend.title.y = window.innerWidth > 1023 ? 25 : 15
            AccidentTrend.title.x = window.innerWidth > 1023 ? 20 : 10
            AccidentTrend.title.style = window.innerWidth > 1023 ? {
                fontFamily: 'Stolzl-Medium',
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: '18px',
                lineHeight: '30px',
                color: '#3D3935'
            } : {
                fontFamily: 'Stolzl-Medium',
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px',
                color: '#3D3935'
            }
        }
        AccidentTrend.series[0].data = temp
        AccidentTrend.xAxis.categories = categories
        AccidentTrend.title.text = t('accident_trend')
        return {...AccidentTrend}
    }

    const CasualtySeverityConfig = () => {
        CasualtySeverity.chart.height = window.innerWidth > 1023 ? 175 : window.innerWidth > 767 ? 149 : 143
        if (window.innerWidth > 1023) {
            CasualtySeverity.chart.width = 462
        } else {
            if (window.innerWidth > 767) {
                CasualtySeverity.chart.width = 334
            }
        }
        CasualtySeverity.title.y = window.innerWidth > 1023 ? 25 : 15
        CasualtySeverity.title.x = window.innerWidth > 1023 ? 20 : 0
        CasualtySeverity.xAxis.labels.style.fontSize = window.innerWidth > 1023 ? 12 : 11
        CasualtySeverity.plotOptions.bar.dataLabels.style.fontSize = window.innerWidth > 1023 ? 12 : 11
        CasualtySeverity.chart.marginTop = window.innerWidth > 1023 ? 55 : 40
        CasualtySeverity.title.text = t('сasualty_severity')
        if (dataAll.casualtySeverity.NoInjuries !== 0) {
            CasualtySeverity.xAxis.categories = [
                {name: t('severity_no_injuries'), key: 'NoInjuries'},
                {name: t('severity_moderate'), key: 'Moderate'},
                {name: t('severity_serious'), key: 'Serious'},
                {name: t('severity_deaths'), key: 'Fatal'}]
            CasualtySeverity.series[0].colors = ['#87EEB0', '#B3A1F9', '#EE8D80', '#575A5E']
        } else {
            CasualtySeverity.xAxis.categories = [
                {name: t('severity_moderate'), key: 'Moderate'},
                {name: t('severity_serious'), key: 'Serious'},
                {name: t('severity_deaths'), key: 'Fatal'}]
        }

        CasualtySeverity.series[0].data = createArray(dataAll?.casualtySeverity, CasualtySeverity.xAxis.categories)
        CasualtySeverity.title.style = window.innerWidth > 1023 ? {
            fontFamily: 'Stolzl-Medium',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: '18px',
            lineHeight: '30px',
            color: '#3D3935'
        } : {
            fontFamily: 'Stolzl-Medium',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#3D3935'
        }
        return {...CasualtySeverity}
    }

    const CasualtiesByUserGroupConfig = () => {
        CasualtiesByUserGroup.chart.height = window.innerWidth > 1023 ? 338 : window.innerWidth > 768 ? 276 : 216
        CasualtiesByUserGroup.title.y = window.innerWidth > 1023 ? 25 : 15
        CasualtiesByUserGroup.title.x = window.innerWidth > 1023 ? 20 : 0
        CasualtiesByUserGroup.chart.marginTop = window.innerWidth > 1023 ? 55 : 40
        CasualtiesByUserGroup.title.text = t('user_group')
        CasualtiesByUserGroup.series[0].data[0].name = dataAll?.casualtyUserGroup?.Cars.toString() + '%'
        CasualtiesByUserGroup.series[0].data[1].value =
            (dataAll?.casualtyUserGroup?.Cars < 11 && dataAll?.casualtyUserGroup?.Cars > 0) ?
                10 : dataAll?.casualtyUserGroup?.Cars
        CasualtiesByUserGroup.series[0].data[2].name = dataAll?.casualtyUserGroup?.Bikes.toString() + '%'
        CasualtiesByUserGroup.series[0].data[3].value =
            (dataAll?.casualtyUserGroup?.Bikes < 11 && dataAll?.casualtyUserGroup?.Bikes > 0) ?
                10 : dataAll?.casualtyUserGroup?.Bikes
        CasualtiesByUserGroup.series[0].data[4].name = dataAll?.casualtyUserGroup?.Motorcycles.toString() + '%'
        CasualtiesByUserGroup.series[0].data[5].value =
            (dataAll?.casualtyUserGroup?.Motorcycles < 11 && dataAll?.casualtyUserGroup?.Motorcycles > 0) ?
                10 : dataAll?.casualtyUserGroup?.Motorcycles
        CasualtiesByUserGroup.series[0].data[6].name = dataAll?.casualtyUserGroup?.Other.toString() + '%'
        CasualtiesByUserGroup.series[0].data[7].value =
            (dataAll?.casualtyUserGroup?.Other < 11 && dataAll?.casualtyUserGroup?.Other > 0) ?
                10 : dataAll?.casualtyUserGroup?.Other
        CasualtiesByUserGroup.series[0].data[8].name = dataAll?.casualtyUserGroup?.Pedestrians.toString() + '%'
        CasualtiesByUserGroup.series[0].data[9].value =
            (dataAll?.casualtyUserGroup?.Pedestrians < 11 && dataAll?.casualtyUserGroup?.Pedestrians > 0) ?
                10 : dataAll?.casualtyUserGroup?.Pedestrians
        // CasualtiesByUserGroup.chart.width = 342
        CasualtiesByUserGroup.chart.backgroundColor = "#F5F5F5"
        CasualtiesByUserGroup.chart.borderWidth = 1
        CasualtiesByUserGroup.chart.borderColor = "#F5F5F5"
        CasualtiesByUserGroup.series[0].levels[0].layoutAlgorithm = 'sliceAndDice'
        CasualtiesByUserGroup.title.style = window.innerWidth > 1023 ? {
            fontFamily: 'Stolzl-Medium',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: '18px',
            lineHeight: '30px',
            color: '#3D3935'
        } : {
            fontFamily: 'Stolzl-Medium',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#3D3935'
        }
        CasualtiesByUserGroup.series[0].levels[0].dataLabels.style = window.innerWidth > 1023 ? {
            fontFamily: 'Roboto',
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: '24px',
            lineHeight: '36px',
            color: '#3D3935'
        } : window.innerWidth > 767 ? {
            fontFamily: 'Roboto',
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: '20px',
            lineHeight: '30px',
            color: '#3D3935'
        } : {
            fontFamily: 'Roboto',
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#3D3935'
        }
        if (window.innerWidth > 1023) {
            CasualtiesByUserGroup.chart.width = 462
        } else {
            if (window.innerWidth > 767) {
                CasualtiesByUserGroup.chart.width = 334
            }
        }
        return {...CasualtiesByUserGroup}
    }

    const CasualtyAgeConfig = () => {
        CasualtyAge.series[0].data = createArray(dataAll?.casualtyAge, CasualtyAge.xAxis.categories)
        CasualtyAge.title.text = t('сasualty_age')
        CasualtyAge.chart.height = window.innerWidth > 1023 ? 175 : window.innerWidth > 767 ? 149 : 143
        if (window.innerWidth > 1023) {
            CasualtyAge.chart.width = 462
        } else {
            if (window.innerWidth > 767) {
                CasualtyAge.chart.width = 334
            }
        }
        CasualtyAge.chart.height = window.innerWidth > 1023 ? 175 : window.innerWidth > 768 ? 149 : 143
        CasualtyAge.title.y = window.innerWidth > 1023 ? 25 : 15
        CasualtyAge.title.x = window.innerWidth > 1023 ? 20 : 0
        CasualtyAge.xAxis.labels.style.fontSize = window.innerWidth > 1023 ? 12 : 11
        CasualtyAge.plotOptions.bar.dataLabels.style.fontSize = window.innerWidth > 1023 ? 12 : 11
        CasualtyAge.chart.marginTop = window.innerWidth > 1023 ? 55 : 40
        CasualtyAge.title.style = window.innerWidth > 1023 ? {
            fontFamily: 'Stolzl-Medium',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: '18px',
            lineHeight: '30px',
            color: '#3D3935'
        } : {
            fontFamily: 'Stolzl-Medium',
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#3D3935'
        }
        return {...CasualtyAge}
    }


    return (<>
        <TopBarHeader elevation={elevation}/>
        <div className="mainContainer">
            <main className="body">
                <div className="mainTitle">
                    {t('report_ready')}
                </div>
                <div className="image-wrapper">
                    <div>
                        <div style={{display: 'flex', textAlign: "left", marginTop: 30, paddingBottom: 20}}>
                            <img src={homeLocation} alt="House" className="imgHouse"/>
                            <span className="titleSpeedTop">
                            {addressStart}
                        </span>
                        </div>
                        <GauageHighChartContainer config={GaugeConfig()}/>
                        <div style={{position: "relative"}}>
                            <div className="safetyScore">{t('safety_score')}</div>
                        </div>
                        <div className="page3Text" style={{marginTop: -20}}>{t("report_spots_1")}</div>
                        <LoadScript
                            id="script-loader"
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                            language={i18n.language}
                            region={'CH'}
                            libraries={libraries}
                            version="weekly">
                            <GoogleMapComponent center={center} markers={markers300m} url={`/AlertCircle.svg`}
                                                zoom={menu ? 15 : 16}/>
                            <div className="page3Text">{t("report_spots_2")}</div>

                            <GoogleMapComponent center={center} markers={markers10km} url={`/Alert.svg`}
                                                zoom={menu ? 12 : 14}/>
                        </LoadScript>
                    </div>
                    <div className="blockAlertText">
                        <img src={Alert} alt="alert" className="imageAlert"/>
                        <div className="titleAlert">{t('spots_description')}</div>
                    </div>
                    <div className="page3Text marginTop30">{t("days_hours_chart_title")}</div>
                    <div style={{marginTop: 20}}>
                        <CasualtiesByUserGroupContainer config={HeatMapConfig()}/>
                    </div>
                    <div className="marginTop10">
                        <GauageHighChartContainer config={AccidentTrendConfig()}/>
                    </div>
                    <div className="AccidentsHappenWhen">
                        <div className="accidentsHappenWhenTitleText">{t('accident_condition')}</div>
                        <div className="AccidentsHappenWhenTopBlock">
                            <div className="accidentsHappenBlock">
                                <img src={Night} className="image" alt="Night"/>
                                <div style={{marginLeft: 0}}>
                                    <div className="AccidentsHappenWhenText">{t('condition_night')}</div>
                                    <div id="varNight" className="accidentsNumber">
                                        {dataAll?.nightAccidents}%
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                display: "inline-flex",
                                flexDirection: "row",
                                justifyContent: "start",
                                width: 150
                            }}>
                                <img src={Sun} className="image" alt="Sun"/>
                                <div style={{marginLeft: 0}}>
                                    <div className="AccidentsHappenWhenText"
                                         style={{paddingRight: 30}}>{t('condition_good')}</div>
                                    <div className="accidentsNumber">
                                        {dataAll?.weatherStatistic?.goodWeather}%
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="AccidentsHappenWhenBottomBlock">
                            <div className="accidentsHappenBlock">
                                <img src={RoadWet} className="image" alt="Night"/>
                                <div style={{marginLeft: 0}}>
                                    <div className="AccidentsHappenWhenText">{t('condition_wet_road')}</div>
                                    <div id="varNight" className="accidentsNumber">
                                        {dataAll?.weatherStatistic?.wetRoad}%
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                display: "inline-flex",
                                flexDirection: "row",
                                justifyContent: "start",
                                width: 150,
                                paddingLeft: 2
                            }}>
                                <img src={Precipitation} className="image" alt="Sun"/>
                                <div style={{marginLeft: 0}}>
                                    <div className="AccidentsHappenWhenText"
                                         style={{paddingRight: 30}}>{t('condition_precipitation')}</div>
                                    <div className="accidentsNumber">
                                        {dataAll?.weatherStatistic?.precipitation}%
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="marginTop10">
                        <CasualtiesByUserGroupContainer config={CasualtySeverityConfig()}/>
                    </div>
                    <div className="marginTop10">
                        <CasualtiesByUserGroupContainer config={CasualtyAgeConfig()}/>
                    </div>
                    <div className="marginTop10">
                        <CasualtiesByUserGroupContainer config={CasualtiesByUserGroupConfig()}/>
                    </div>
                </div>
                <ButtonGroup/>
            </main>
            <main className="body2">
                <div className="mainTitle">
                    {t('report_ready')}
                </div>
                <div className="image-wrapper">
                    <div className="flexSpaceBetween">
                        <div className="blockColumnLeft">
                            <GauageHighChartContainer config={GaugeConfig()}/>
                            <div className="safetyScore">{t("safety_score")}</div>
                        </div>
                        <div className="blockColumnLeft">
                            <div className=" flexSpaceBetween homeBlock">
                                <img src={homeLocation} alt="House" className="imgHouse"/>
                                <div className="titleSpeedTop">
                                    {addressStart}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flexSpaceBetween">
                        <div className="blockColumnLeft leftGapeBetween">
                            <div className="page3Text">{t("report_spots_1")}</div>
                            <LoadScript
                                id="script-loader"
                                googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                                language={i18n.language}
                                region={'CH'}
                                libraries={libraries}
                                version="weekly">
                                <GoogleMapComponent center={center} markers={markers300m} url={`/AlertCircle.svg`}
                                                    zoom={menu ? 16 : 16}/>
                            </LoadScript>
                        </div>
                        <div className="blockColumnRight rightGapBetween">
                            <LoadScript
                                id="script-loader"
                                googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                                language={i18n.language}
                                region={'CH'}
                                libraries={libraries}
                                version="weekly">
                                {i18n.language?.slice(0, 2) !== 'en' && <div className="page3Text">&nbsp;</div>}
                                <div className="page3Text">{t("report_spots_2")}</div>
                                <GoogleMapComponent center={center} markers={markers10km} url={`/Alert.svg`}
                                                    zoom={menu ? 12 : 14}/>
                            </LoadScript>
                        </div>
                    </div>
                    <div className="blockAlertText">
                        <img src={Alert} alt="alert" className="imageAlert"/>
                        <div className="titleAlert">{t('spots_description')}</div>
                    </div>
                    <div className="page3Text marginTop30">{t("days_hours_chart_title")}</div>
                    <div style={{marginTop: 20}}>
                        <CasualtiesByUserGroupContainer config={HeatMapConfig()}/>
                    </div>
                    <div className="lineGradient"></div>
                    <div className="flexSpaceBetween">
                        <div className="minMaxFrequency">{t('min_frequency')}</div>
                        <div className="minMaxFrequency">{t('max_frequency')}</div>
                    </div>
                    <div className="gapMargin"/>
                    <div className="flexSpaceBetween">
                        <div className="blockColumnLeft leftGapeBetween" style={{margin: 0}}>
                            <CasualtiesByUserGroupContainer config={CasualtyAgeConfig()}/>
                            <div className="gapMargin"/>
                            <GauageHighChartContainer config={AccidentTrendConfig()}/>
                            <div className="gapMargin"/>
                            <div className="AccidentsHappenWhen">
                                <div className="accidentsHappenWhenTitleText">{t('accident_condition')}</div>
                                <div className="AccidentsHappenWhenTopBlock">
                                    <div className="accidentsHappenBlock">
                                        <img src={Night} className="image" alt="Night"/>
                                        <div style={{marginLeft: 0}}>
                                            <div className="AccidentsHappenWhenText">{t('condition_night')}</div>
                                            <div id="varNight" className="accidentsNumber">
                                                {dataAll?.nightAccidents}%
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        justifyContent: "start",
                                        width: 150
                                    }}>
                                        <img src={Sun} className="image" alt="Sun"/>
                                        <div style={{marginLeft: 0}}>
                                            <div className="AccidentsHappenWhenText"
                                                 style={{paddingRight: 30}}>{t('condition_good')}</div>
                                            <div className="accidentsNumber">
                                                {dataAll?.weatherStatistic?.goodWeather}%
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="AccidentsHappenWhenBottomBlock">
                                    <div className="accidentsHappenBlock">
                                        <img src={RoadWet} className="image" alt="Night"/>
                                        <div style={{marginLeft: 0}}>
                                            <div className="AccidentsHappenWhenText">{t('condition_wet_road')}</div>
                                            <div id="varNight" className="accidentsNumber">
                                                {dataAll?.weatherStatistic?.wetRoad}%
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        justifyContent: "start",
                                        width: 150,
                                        paddingLeft: 2
                                    }}>
                                        <img src={Precipitation} className="image" alt="Sun"/>
                                        <div style={{marginLeft: 0}}>
                                            <div className="AccidentsHappenWhenText"
                                                 style={{paddingRight: 30}}>{t('condition_precipitation')}</div>
                                            <div className="accidentsNumber">
                                                {dataAll?.weatherStatistic?.precipitation}%
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="blockColumnRight rightGapBetween" style={{margin: 0}}>
                            <CasualtiesByUserGroupContainer config={CasualtySeverityConfig()}/>
                            <div className="gapMargin"/>
                            <CasualtiesByUserGroupContainer config={CasualtiesByUserGroupConfig()}/>
                        </div>
                    </div>
                </div>
                <ButtonGroup/>
            </main>
        </div>
        <Footer/>
    </>)
}

